export const mapToUpperCase = (items: string[]) => items.map((item) => item.toUpperCase())
